export default "__VITE_ASSET__BK9b2u4y__"